export const PHONE = "210-954-0804";
export const PHONE_TEL = "2109540804";
export const EMAIL = "richard.blake4hire@yahoo.com";
export const LOCATIONS = "Schertz • New Braunfels • San Antonio";
export const FACEBOOK_URL = "https://www.facebook.com/share/17xmK5UU1S/?mibextid=wwXIfr";

// Venmo handle for accepting payments (without the leading @).
export const VENMO_USERNAME = "richard-anderson-102";

// Google review link. To make this a one-tap "write a review" link, replace with
// https://search.google.com/local/writereview?placeid=YOUR_PLACE_ID once the Google
// Business Profile is verified. For now it lands customers on the B3 Google listing.
export const GOOGLE_REVIEW_URL =
  "https://www.google.com/search?q=B3+Contracting+LLC+Schertz+TX+reviews";

// Real customer reviews. Paste verified quotes here and they'll appear automatically.
// Each: { name, rating (1-5), text, source ("Google" | "Facebook"), location }

// A short, punchy quote spotlighted in the hero. Edit anytime to feature a different one.
export const FEATURED_REVIEW = {
  text: "B3 Contracting is amazing — if I could give a million stars, I would!",
  name: "Sydney Capicio",
};

export const REVIEWS = [
  {
    name: "Sydney Capicio",
    rating: 5,
    source: "Facebook",
    text: "B3 Contracting is AMAZING! If I could give it a million stars I would! Blake is so helpful and knowledgeable, and really takes his time to take care of his clients and his work. 10/10 amazing services!",
  },
  {
    name: "Chasta Mendiola",
    rating: 5,
    source: "Facebook",
    text: "Great company, quality work and I will absolutely be hiring them again and again. I can't begin to tell you how respectful and professional Blake was. He was responsive, prompt and had reasonable prices.",
  },
  {
    name: "Myra GP",
    rating: 5,
    source: "Facebook",
    text: "I was left with an unsightly area on my porch following foundation repair. Richard was very responsive and we came up with a cost-effective solution within one day. Dontrey did an amazing job repairing the concrete on my front porch! I'm super grateful for the timing and attention to quality. 10/10 recommend.",
  },
  {
    name: "Kayla Michelle Prado",
    rating: 5,
    source: "Facebook",
    text: "B3 Contracting delivered exactly what we hoped for and more. Professional, flexible, and genuinely skilled — they made the whole process easy from start to finish. The lights came out stunning, and watching our grandmother light up with joy was the best part of all. Thank you, B3 — you made this surprise unforgettable!",
  },
  {
    name: "Dan Francis",
    rating: 5,
    source: "Facebook",
    text: "Blake was fantastic! He went above and beyond, and really delivered. I'll be using them again and again!!!",
  },
  {
    name: "Ileana Canales",
    rating: 5,
    source: "Facebook",
    text: "B3 Contracting has been my go-to for Christmas light installation and take-down going on 3 years! Excellent work, great communication, and always accommodating to my schedule!",
  },
  {
    name: "Melissa Hugo",
    rating: 5,
    source: "Facebook",
    text: "Blake has done our Christmas lights for 2 years now and done a really great job! He goes above and beyond to ensure that they are working and has been very helpful troubleshooting any issues if they arrive. Thank you Blake!",
  },
  {
    name: "Haley Martin",
    rating: 5,
    source: "Facebook",
    text: "I needed someone to take down our Christmas lights as the person who put them up was unavailable. I contacted B3 on Monday morning and they came that evening. They gave a quote before coming and the price was very reasonable. Blake was professional and friendly. I'd recommend them to anyone. Looking forward to working with them again.",
  },
  {
    name: "Matt Budd",
    rating: 5,
    source: "Facebook",
    text: "Provides top notch work with affordable rates! 10/10 recommend!",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjb250cmFjdG9yJTIwYnVpbGRpbmclMjBob21lJTIwcmVtb2RlbGluZ3xlbnwwfHx8fDE3ODY5OTk1OTJ8MA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxob21lJTIwcmVtb2RlbGluZyUyMGludGVyaW9yJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3ODY5OTk3OTB8MA&ixlib=rb-4.1.0&q=85",
  cta: "https://images.unsplash.com/photo-1546827209-a218e99fdbe9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxjcmFmdHNtYW4lMjB0b29scyUyMHdvb2QlMjBjb25jcmV0ZXxlbnwwfHx8fDE3ODY5OTk1OTJ8MA&ixlib=rb-4.1.0&q=85",
  area: "https://images.unsplash.com/photo-1514510249063-e0faf6c6ec0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxTYW4lMjBBbnRvbmlvJTIwVGV4YXMlMjBza3lsaW5lfGVufDB8fHx8MTc4Njk5OTc5MHww&ixlib=rb-4.1.0&q=85",
};

export const GUARANTEE =
  "Every B3 Contracting project is backed by our commitment to doing it right: a clear written estimate up front, honest communication throughout, a tidy job site, and a final walkthrough before we call it done. If something isn't right, we make it right.";

export const QUALITY_POINTS = [
  { title: "Quality Workmanship", desc: "We sweat the details and take pride in work that holds up over time." },
  { title: "Clear Communication", desc: "You'll always know the plan, the timeline and the price before we start." },
  { title: "Dependable Scheduling", desc: "We show up when we say we will and keep your project moving." },
  { title: "Locally Owned", desc: "A Schertz family business that treats your home like our own." },
];

export const SERVICES = [
  {
    icon: "HardHat", slug: "general-contracting", title: "General Contracting", featured: true,
    desc: "Project coordination and construction services for a wide range of residential and property improvement needs.",
    long: "As your general contractor, B3 Contracting manages the whole project from first conversation to final walkthrough — planning, scheduling, coordinating the right trades and keeping the work on track. One point of contact, one team accountable for the result.",
    includes: ["Free written estimates", "Project planning & coordination", "Licensed trade coordination", "Clean, organized job sites", "Regular progress updates", "Final walkthrough with you"],
  },
  {
    icon: "House", slug: "home-remodeling", title: "Home Remodeling",
    desc: "Refresh, improve or transform your existing spaces with practical remodeling solutions.",
    long: "Whether you're updating a single room or reworking your whole layout, we help you refresh and transform your home with practical, quality remodeling. We focus on durable materials, clean finishes and results you'll enjoy every day.",
    includes: ["Interior & full-home remodels", "Layout & finish updates", "Quality, durable materials", "Honest, itemized pricing", "Tidy daily cleanup", "Workmanship you can count on"],
  },
  {
    icon: "Wind", slug: "hvac", title: "HVAC",
    desc: "Heating and cooling related services designed to help keep properties comfortable and functioning properly.",
    long: "Keep your home comfortable year-round. We handle heating and cooling services to help your system run properly and efficiently, with straightforward recommendations and no upselling.",
    includes: ["Heating & cooling services", "System checks & maintenance", "Straightforward recommendations", "Comfort-focused solutions", "Clear pricing", "Reliable scheduling"],
  },
  {
    icon: "PaintRoller", slug: "painting", title: "Painting",
    desc: "Interior and exterior painting to give your home or property a clean, finished look.",
    long: "A fresh coat of paint is one of the best-value upgrades for any home. We deliver clean lines, proper prep and a durable, finished look inside and out.",
    includes: ["Interior & exterior painting", "Thorough surface prep", "Clean lines & even coverage", "Quality paints & materials", "Careful masking & cleanup", "Long-lasting finish"],
  },
  {
    icon: "Barricade", slug: "fence-building", title: "Fence Building",
    desc: "New fence construction, replacement and repair for residential and property needs.",
    long: "New fence, replacement or repair — we build fences that look great and stand up to Texas weather. Privacy, security or curb appeal, we've got you covered.",
    includes: ["New fence construction", "Fence replacement & repair", "Wood & privacy fencing", "Sturdy, weather-ready builds", "Clean removal of old fencing", "Free on-site estimates"],
  },
  {
    icon: "Bathtub", slug: "kitchen-bathroom", title: "Kitchen & Bathroom",
    desc: "Upgrade kitchens and bathrooms with functional improvements and a fresh new finish.",
    long: "Kitchens and bathrooms are where quality shows. We upgrade the spaces you use most with functional improvements and fresh, durable finishes.",
    includes: ["Kitchen & bath remodels", "Cabinets, counters & fixtures", "Tile & finish work", "Functional layout upgrades", "Quality, water-ready materials", "Detailed final finish"],
  },
  {
    icon: "Buildings", slug: "home-additions", title: "Home Additions", featured: true,
    desc: "Expand your living space with thoughtfully planned additions and improvements.",
    long: "Need more space? We plan and build additions that blend seamlessly with your existing home — more room to live, thoughtfully done and built to last.",
    includes: ["Room & living-space additions", "Thoughtful, blended design", "Full project coordination", "Quality structural work", "Clear timelines & pricing", "Final walkthrough"],
  },
  {
    icon: "Cube", slug: "concrete-outdoor", title: "Concrete & Outdoor",
    desc: "Concrete, decks and outdoor projects that improve the function and appearance of your property.",
    long: "From concrete work to decks and outdoor living, we improve how your property looks and functions — built to handle everyday use and the elements.",
    includes: ["Concrete & flatwork", "Decks & outdoor living", "Durable, weather-ready builds", "Improved curb appeal", "Clean job sites", "Free estimates"],
  },
  {
    icon: "GridFour", slug: "flooring", title: "Flooring",
    desc: "Flooring installation and replacement for a variety of residential applications.",
    long: "New flooring transforms a room instantly. We install and replace flooring with precise prep and clean, level results across a variety of materials.",
    includes: ["Flooring installation & replacement", "Careful subfloor prep", "Clean, level results", "A range of material options", "Tidy removal of old flooring", "Quality craftsmanship"],
  },
  {
    icon: "Wrench", slug: "drywall-repairs", title: "Drywall & Repairs",
    desc: "Drywall installation, repairs and general home maintenance projects.",
    long: "From patches to full installs, plus the general repairs every home needs — we handle the fix-it list so your home stays in great shape.",
    includes: ["Drywall installation & repair", "Patching & texture matching", "General home repairs", "Honest, no-pressure pricing", "Clean, careful work", "Reliable scheduling"],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);


export const WHY = [
  { n: "01", title: "Quality Workmanship", desc: "We take pride in doing the job right." },
  { n: "02", title: "Reliable Service", desc: "Clear communication and dependable scheduling." },
  { n: "03", title: "Multiple Services", desc: "One point of contact for a broad range of projects." },
];

export const AREAS = [
  "Schertz", "New Braunfels", "San Antonio", "Cibolo", "Universal City",
  "Selma", "Live Oak", "Converse", "Garden Ridge", "Seguin", "Surrounding Areas",
];

export const PROJECT_TYPES = [
  "General Contracting", "Home Remodeling", "HVAC", "Painting", "Fence Building",
  "Kitchen & Bathroom", "Home Addition", "Concrete / Outdoor", "Flooring",
  "Drywall / Repairs", "Other",
];
